import { Form } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import { OptionFormGroup } from '@/App/tiles/Option/fields/OptionFormGroup.tsx';
import { useOptionSelector } from '@/App/tiles/Option/OptionContext.ts';
import { useCheckOption } from '@/App/tiles/Option/QueueContext.tsx';

export const CrossCurrency = () => {
  const { crossCurrenciesList, crossCurrency, isCrossed, tileId } = useOptionSelector((option) => ({
    isCrossed: option.properties.isCrossed,
    crossCurrency: option.properties.crossCurrency,
    crossCurrenciesList: option.properties.crossCurrenciesList,
    tileId: option.properties.tileId,
  }));

  const [checkOption] = useCheckOption();

  function handleCrossCurrencySwitch(event: React.ChangeEvent<HTMLSelectElement>) {
    return checkOption({
      tileId,
      properties: {
        crossCurrency: event.target.value,
      },
    });
  }

  function handleChange(value: boolean) {
    return checkOption({
      tileId,
      properties: {
        isCrossed: value,
      },
    });
  }

  return (
    <OptionFormGroup label={<FormattedMessage id={'option.fields.crossCurrency'} />}>
      <div className="d-flex gap-2 align-items-center flex-grow-1">
        <div className="form-check form-check-sm">
          <input
            id="isCrossed"
            className="form-check-input"
            type="checkbox"
            checked={isCrossed}
            onChange={(e) => handleChange(e.target.checked)}
            data-e2e="isCrossed-checkbox"
          />
          {/* oxlint-disable-next-line label-has-associated-control -- otherwise checkbox has no width */}
          <label htmlFor="isCrossed" className="form-check-label" />
        </div>
        {isCrossed && (
          <Form.Select
            className="flex-grow-1"
            value={crossCurrency}
            onChange={handleCrossCurrencySwitch}
            size="sm"
            data-e2e="cross-currency-selector"
          >
            {crossCurrenciesList?.map((currency) => (
              <option key={currency} value={currency}>
                {currency}
              </option>
            ))}
          </Form.Select>
        )}
      </div>
    </OptionFormGroup>
  );
};
